import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface PublishOcpIntroduction {
  actionName: 'publishOcpIntroduction';
  request: mtechnavi.api.company.IBusinessUnitIntroduction;
}

export const publishOcpIntroduction = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IBusinessUnitIntroduction
) => {
  const publishMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/PublishBusinessUnitIntroduction';

  return worker.invokeListRequest(publishMethodName, {
    businessUnitIntroduction: req,
  });
};
